import { Suspense, useMemo } from "react";
import { Outlet } from "react-router-dom";
import { Footer } from "@/components/layout/Footer";
import { EmailVerificationBanner } from "@/components/auth/EmailVerificationBanner";
import { AppHeader } from "@/components/navigation/AppHeader";
import { Loading } from "@/components/ui/loading";
import { useAuth } from "@/contexts/AuthContext";
import { getSiteNav } from "@/lib/navigation";

/** Publikus és vendégoldalak kerete: fejléc, e-mail megerősítő sáv, tartalom, lábléc */
export function SiteLayout() {
  const { user } = useAuth();
  const signedIn = !!user;
  const isAdmin = !!user?.isAdmin;
  const nav = useMemo(() => getSiteNav({ signedIn, isAdmin }), [signedIn, isAdmin]);

  return (
    <>
      <AppHeader nav={nav} />
      {/* Oszlopos flex: így tudja egy oldal kerete (`PageContainer`) a `grow`-val a
          lábléc aljáig húzni a saját hátterét, rövid tartalom mellett is */}
      <main className="flex grow flex-col">
        <div className="container mx-auto px-4">
          <EmailVerificationBanner />
        </div>
        {/* Az oldalak kódja külön töltődik (lásd pages/lazyPages.ts); a fejléc közben már látszik */}
        <Suspense fallback={<Loading label="Oldal betöltése..." />}>
          <Outlet />
        </Suspense>
      </main>
      <Footer />
    </>
  );
}
